// CHANGES TO THIS FILE MAY CAUSE INCORRECT BEHAVIOR AND WILL BE LOST IF THE CODE IS REGENERATED
// auto-generated on 10/10/2024 1:24:55 PM by John Caccavaro's (caccavaro123@gmail.com) Frameworks tool.

/* eslint-disable @typescript-eslint/no-empty-interface */

import { ConnectionStatusTypeEnum } from '../appCore/models/schema/Schema';

export enum IntegrationTypeEnum {
  people = 0,
}

export enum ConnectEnum {
  invalidCompanyId = 0,
}

export enum DisconnectEnum {
  invalidCompanyId = 0,
}

export enum GetInitialStateEnum {
  invalidCompanyId = 0,
}

export enum GetUserListEnum {
  invalidCompanyId = 0,
}

export enum SyncEmployeeEnum {
  invalidCompanyId = 0,
}

export enum RenewTokenEnum {
  invalidCompanyId = 0,
}

export enum PersistEmployeeEnum {
  invalidCompanyId = 0,
}

export interface ConnectRequestInterface {
  integrationType: IntegrationTypeEnum;
  companyId: number;
  emailAddress: string;
}

export interface ConnectResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface DisconnectRequestInterface {
  integrationType: IntegrationTypeEnum;
  companyId: number;
}

export interface DisconnectResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface GetInitialStateRequestInterface {
  integrationType: IntegrationTypeEnum;
  companyId: number;
  includeEmployeeDetails: boolean;
}

export interface GetInitialStateResponseInterface {
  connectionStatus: ConnectionStatusTypeEnum;
  authorizationUri: string;
  syncedEmployeeCount: number;
  syncedAllEmployees: boolean;
  newEmployeesAdded: boolean;
  validationResults: ValidationResultsInterface;
}

export interface GetUserListRequestInterface {
  integrationType: IntegrationTypeEnum;
  companyId: number;
}

export interface GetUserListResponseInterface {
  hasMatched: boolean;
  userList: Array<UserInterface>;
  externalUserList: Array<UserInterface>;
  validationResults: ValidationResultsInterface;
}

export interface SyncEmployeeRequestInterface {
  integrationType: IntegrationTypeEnum;
  companyId: number;
  userCorrelationList: Array<UserCorrelationInterface>;
}

export interface SyncEmployeeResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface RenewTokenRequestInterface {
  integrationType: IntegrationTypeEnum;
  companyId: number;
}

export interface RenewTokenResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface PersistEmployeeRequestInterface {
  integrationType: IntegrationTypeEnum;
  companyId: number;
}

export interface PersistEmployeeResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface UserInterface {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  isNew: boolean;
  userCorrelation?: UserCorrelationInterface;
}

export interface UserCorrelationInterface {
  externalEmployeeId?: number;
  wagepointEmployeeId?: number;
  doNotMap: boolean;
  addNewProfile: boolean;
}

export enum ValidationSeverityEnum {
  NotDefined = 0,
  Passed,
  Information,
  Warning,
  Error,
}

export interface ValidationResultInterface {
  validationSeverityEnum: ValidationSeverityEnum;
  validationMessage: string;
  exceptionInformation: string;
  validationCode: number;
  validationTag: string;
  isValid: boolean;
}

export interface ValidationResultsInterface {
  validationResultList?: Array<ValidationResultInterface>;
}

import { Post } from '../httpClient';

export class HrManagerService {
  connect(request: ConnectRequestInterface): Promise<ConnectResponseInterface> {
    return Post('/PayrollHrManager/connect', request);
  }

  disconnect(request: DisconnectRequestInterface): Promise<DisconnectResponseInterface> {
    return Post('/PayrollHrManager/disconnect', request);
  }

  getInitialState(request: GetInitialStateRequestInterface): Promise<GetInitialStateResponseInterface> {
    return Post('/PayrollHrManager/getInitialState', request);
  }

  getUserList(request: GetUserListRequestInterface): Promise<GetUserListResponseInterface> {
    return Post('/PayrollHrManager/getUserList', request);
  }

  syncEmployee(request: SyncEmployeeRequestInterface): Promise<SyncEmployeeResponseInterface> {
    return Post('/PayrollHrManager/syncEmployee', request);
  }

  renewToken(request: RenewTokenRequestInterface): Promise<RenewTokenResponseInterface> {
    return Post('/PayrollHrManager/renewToken', request);
  }

  persistEmployee(request: PersistEmployeeRequestInterface): Promise<PersistEmployeeResponseInterface> {
    return Post('/PayrollHrManager/persistEmployee', request);
  }
}

export default new HrManagerService();
